// actionTypes.js
export const SET_VALUE_PME = "SET_VALUE_PME";
export const SET_CURRENT_PAGE_PME = "SET_CURRENT_PAGE_PME";
export const SET_ORDER_PME = "SET_ORDER_PME";
export const SET_SORT_FIELD_PME = "SET_SORT_FIELD_PME";
export const SET_PAGE_SIZE_PME = "SET_PAGE_SIZE_PME";
export const SET_CUSTOM_FILTERS_PME = "SET_CUSTOM_FILTERS_PME";
export const SET_SORTING_PME = "SET_SORTING_PME";
export const SET_ACTIVE_TAB_PME = "SET_ACTIVE_TAB_PME";
export const SET_QUERY_PME = "SET_QUERY_PME";
export const SET_ACTIF_PME = "SET_ACTIF_PME";
export const SET_SELECTED_OPTION_FILTERS_PME =
  "SET_SELECTED_OPTION_FILTERS_PME";
export const SET_SELECTED_OPTION_ID_PME = "SET_SELECTED_OPTION_ID_PME";
export const SET_COLUMN_PME = "SET_COLUMN_PME";
